<template>
    <div class="labels-wrapper">
        <div class="left-label"></div>
        <div class="right-label" :style="{backgroundColor}">
            <div class="label-text">
                {{rightLabel}}
            </div>
        </div>
    </div>
</template>

<script>
import { getRightLabel } from '../../../helpers/streams';

export default {
    name: 'DefaultLabels',
    props: {
        item: { type: Object }
    },
    computed: {
        rightLabel() {
            return getRightLabel(this.item.type);
        },
        backgroundColor() {
            return this.item.type.match(/^(hd|pano)$/) ? 'rgba(30, 30, 30, 0.8)' : ''
        }
    }
}
</script>
